











import Vue from 'vue';
import { mapState } from 'vuex';
import Helpers from '@/mixins/helpers';
export default Vue.extend({
	name: 'FinanceDetails', 
	computed: {
		...mapState({
			finance(): any { return this.$store.state.finance }
		}), 
		financeHeadingListItems(): Array<string> {
			return Helpers.getFinanceHeadingListItems(this.finance.financeHeading);
		}
	}
});
